module.exports = __webpack_public_path__ + "img/5a4338c.jpg";